module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Avaliados")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.periodosOrdenados), function(periodo) {
    return _c('tr', {
      key: periodo.id,
      class: _vm.situacaoPendente(periodo, 'class')
    }, [_c('td', [_vm._v(_vm._s(periodo.avaliado.pessoa.nome))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.mostraNota(periodo)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                        " + _vm._s(_vm.situacaoAtual(periodo) ?
      'EM ANDAMENTO' :
      'FINALIZADA') + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "td-btns td-btns-alone"
    }, [_c('botao', {
      attrs: {
        "estilo": _vm.situacaoPendente(periodo, 'estilo'),
        "icone": _vm.situacaoAtual(periodo) ?
          'editar-tabela' :
          'visualizar'
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(periodo.avaliado.id)
        }
      }
    })], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer-controller-inner"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  })], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Notas Atribuídas")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v(" ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-617e108c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/avaliacao/avaliados.vue
// module id = Onna
// module chunks = 5